<script setup>

import { ref, defineProps, defineEmits, computed} from "vue";
import useColaboradorStore from '../../api/v2/stores/ColaboradorStore';
import Text from "../../utils/Text.js"

const props = defineProps(['aberto'])
const emits = defineEmits(['update:aberto'])



const colaboradorStore = useColaboradorStore();
const colaboradorNome = colaboradorStore.colaborador.nome;


const justificativa = ref("");
const justificativaValida = computed(()=>{

    if(Text.equalTo(justificativa.value,0)){
        return true;
    }

    return Text.greatherOrEqualTo(justificativa.value,140);

});
const justificativaRegras = [
    valor => {
        if(Text.equalTo(valor,0)){
            return true;
        }
        if(Text.lessThanOrEqualTo(valor,140)){
            return true;
        }
        return 'Justificativa deve ter menos de 140 caracteres.';
    }
];



const fechar = () => {

    emits('update:aberto', {
        justificativa: justificativa.value,
        resultado: false
    });

    justificativa.value = "";

};

const confirmar = () => {

    emits('update:aberto', {
        justificativa: justificativa.value,
        resultado: true
    });

    justificativa.value = "";

};

</script>

<template>

    <main>

        <v-dialog
            v-model="props.aberto"
            overlay-color="black"
            overlay-opacity="0.4"
            origin="center center"
            persistent
        >

            <v-card
                class="c-modal"
            >

                <v-card-title 
                    primary-title
                >

                    <v-icon 
                        left
                        large
                        color="blue darken-2"
                    >
                        mdi-comment-processing-outline
                    </v-icon>

                    {{colaboradorNome}}, justifique o retorno dos Itens.

                </v-card-title>

                <v-card-text>

                    <v-textarea
                        v-model="justificativa"
                        outlined
                        clearable
                        label="Justificativa"
                        variant="outlined"
                        no-resize
                        :rules="justificativaRegras"
                    >
                    </v-textarea>

                </v-card-text>

                <v-divider></v-divider>
                
                <v-card-actions>

                    <v-spacer></v-spacer>

                    <v-btn 
                        color="error"
                        @click="fechar"
                    >
                        Cancelar
                    </v-btn>

                    <v-btn 
                        color="primary"
                        @click="confirmar"
                        :disabled="justificativaValida"
                    >
                        Confirmar
                    </v-btn>

                </v-card-actions>

            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content{
    display: grid;
    align-content: center;
    justify-content: center;
    position: fixed;
    width: 100vw;
    height: 100vh;
    /*Reversão de Propriedades*/
    left: initial;
    top: initial;
    outline: initial;
}

.v-dialog__content >>> .v-dialog{
    /*Reversão de Propriedades*/
    max-height: initial;
    margin: initial;
    z-index: initial;
    outline: initial;
}

.c-modal{
    display: grid;
    width: 100vw;
    max-width: 650px;
}

</style>